export default __webpack_public_path__ + "static/media/PreventionImpressum.617878e9.md";